import React, { useState } from "react";

// ANT DESIGN IMPORT
import { Row, Tag, Card, Col, Statistic } from "antd";
import {
  SafetyOutlined,
  SettingOutlined,
  UserAddOutlined,
  UserSwitchOutlined,
  DoubleRightOutlined,
  DownloadOutlined,
  CalculatorOutlined,
  VerticalAlignMiddleOutlined,
  HolderOutlined,
  CloseCircleOutlined,
  EditOutlined,
  UploadOutlined,
  WalletOutlined,
  SwapOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  UsergroupAddOutlined,
  CloseOutlined,
} from "@ant-design/icons";

//PROJECT IMPORT
import { BOM } from "../../services/definedMethod";
import { handleFlgStatus } from "./AccountFacility";

export const GroupFacility = (props) => {
  const {
    accountName,
    accountNo,
    officeName,
    centerName,
    status,
    accDetail,
    groupDetail,
  } = props;
  return (
    <Card
      bordered={true}
      bodyStyle={{
        paddingTop: 12,
        paddingBottom: 12,
        // paddingLeft: 24,
      }}
      hoverable={true}
      style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
    >
      <Row>
        <Col span={8}>
          <Statistic
            title={"Account Name"}
            value={accountName ? BOM.SubstringFormat(accountName, 20) : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />

          <Statistic
            title={"Account Number"}
            value={" "}
            prefix={accountNo ? accountNo : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />
        </Col>

        <Col span={8}>
          <Statistic
            title={"Branch Name"}
            value={" "}
            prefix={officeName ? officeName : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />

          <Statistic
            title={"Center Name"}
            value={" "}
            prefix={centerName ? centerName : "-"}
            valueStyle={{
              fontSize: "16px",
            }}
          />
        </Col>
        <Col span={8}>
          {status?.value
            ? handleFlgStatus(
                status?.value,
                {
                  fontSize: 16,
                },
                false,
                accDetail
              )
            : "-"}
        </Col>
      </Row>
    </Card>
  );
};

export const handleGroupDetailActionButtons = (groupDetail) => {
  const status = groupDetail?.status?.value;
  const { staffName } = groupDetail;

  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Activate",
          key: "1",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_GROUP"),
          icon: <CheckCircleOutlined />,
        },

        {
          label: `${staffName ? "Unassign" : "Assign"} Staff`,
          key: "2",
          route: !staffName && "/group-account-action",
          disabled: staffName
            ? !BOM.HasPermission("UNASSIGNSTAFF_GROUP")
            : !BOM.HasPermission("ASSIGNSTAFF_GROUP"),
          icon: staffName ? <UserSwitchOutlined /> : <UserAddOutlined />,
        },
        {
          label: "Close",
          key: "4",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CLOSE_GROUP"),
          icon: <CloseCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Group Savings Application",
          key: "1",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNT"),
          icon: <PlusCircleOutlined />,
        },
        {
          label: "Group Savings (Individual Monitoring) Application",
          key: "2",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNT"),
          icon: <PlusCircleOutlined />,
        },
        {
          label: "Group Loan Application",
          key: "3",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CREATE_LOAN"),
          icon: <PlusCircleOutlined />,
        },
        {
          label: "Group Loan (Individual Monitoring) Application",
          key: "5",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CREATE_LOAN"),
          icon: <PlusCircleOutlined />,
        },
        {
          label: `${
            groupDetail.hasOwnProperty("collectionMeetingCalendar")
              ? "Attendance"
              : "Attach Meeting"
          }`,
          key: "6",
          route: "/group-account-action",
          disabled: groupDetail.hasOwnProperty("collectionMeetingCalendar")
            ? !BOM.HasPermission("SAVEORUPDATEATTENDANCE_MEETING")
            : !BOM.HasPermission("CREATE_MEETING"),
          icon: <UsergroupAddOutlined />,
        },
        {
          label: `${staffName ? "Unassign" : "Assign"} Staff`,
          key: "7",
          route: !staffName && "/group-account-action",
          disabled: staffName
            ? !BOM.HasPermission("UNASSIGNSTAFF_GROUP")
            : !staffName && !BOM.HasPermission("ASSIGNSTAFF_GROUP"),
          icon: staffName ? <UserSwitchOutlined /> : <UserAddOutlined />,
        },

        {
          label: "Close",
          key: "8",
          route: "/group-account-action",
          disabled: !BOM.HasPermission("CLOSE_GROUP"),
          icon: <CloseCircleOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleManageClientsActionButtons = (groupDetail) => {
  return [
    {
      label: "Transfer Customers",
      key: "1",
      route: "/manage-clients-action",
      disabled: !BOM.HasPermission("TRANSFERCLIENTS_GROUP"),
      icon: <SwapOutlined />,
    },
    {
      label: "Manage Members",
      key: "2",
      route: "/manage-clients-action",
      disabled: !BOM.HasPermission("ASSOCIATECLIENTS_GROUP"),
      icon: <UsergroupAddOutlined />,
    },
    {
      label: "Add Customer",
      key: "3",
      route: "/manage-clients-action",
      disabled: !BOM.HasPermission("CREATE_CLIENT"),
      icon: <UserAddOutlined />,
    },
  ];
};

export const handleGroupSavingsDetailActionButtons = (groupDetail) => {
  const { fieldOfficerName } = groupDetail;
  const status = groupDetail?.status?.value;
  const subStatusBlock = groupDetail?.subStatus?.block; //This needs to be checked later on for hold action implementation
  const subStatusNone = groupDetail?.subStatus?.none; //This needs to be checked later as well
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Approve",
          key: "1",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "2",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission(
            fieldOfficerName
              ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
              : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
          ),
          icon: <UserAddOutlined />,
        },
        {
          label: "Add Charge",
          key: "4",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: "Reject",
          key: "5",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
        {
          label: "Withdrawn by Client",
          key: "6",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("WITHDRAW_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Modify Application",
          key: "7",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
          icon: <EditOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_SAVINGSACCOUNT"),
          icon: <VerticalAlignMiddleOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Add Charge",
          key: "3",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission(
            fieldOfficerName
              ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
              : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
          ),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Post Interest As On",
          key: "1",
          route: "/group-savings-action",
          disabled: true,
          icon: <DoubleRightOutlined />,
        },
        {
          label: "Deposit",
          key: "2",
          route: "/group-savings-action",
          disabled: true,
          icon: <UploadOutlined />,
        },
        {
          label: "Withdraw",
          key: "3",
          route: "/group-savings-action",
          disabled: true,
          icon: <DownloadOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "4",
          disabled:
            subStatusBlock ||
            !BOM.HasPermission("CALCULATEINTEREST_SAVINGSACCOUNT"),
          icon: <CalculatorOutlined />,
        },
        {
          label: "Hold",
          key: "5",
          route: "/group-savings-action",
          disabled: true,
          icon: <HolderOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "6",
          route: "/group-savings-action",
          disabled: subStatusBlock
            ? subStatusNone
            : subStatusBlock ||
              !BOM.HasPermission(
                fieldOfficerName
                  ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
                  : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
              ),
          icon: <UserAddOutlined />,
        },
        {
          label: "Post Interest",
          key: "7",
          disabled:
            subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Charge",
          key: "8",
          route: "/group-savings-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: "Close",
          key: "9",
          route: "/group-savings-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CLOSE_SAVINGSACCOUNT"),
          icon: <CloseOutlined />,
        },
        {
          label: "Manage Account",
          key: "10",
          route: "/group-savings-action",
          disabled: true,
          icon: <EditOutlined />,
        },
        {
          label: "KYC",
          key: "11",
          route: "/group-savings-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.withdrawnByApplicant:
      return [
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/group-savings-action",
          disabled: !BOM.HasPermission(
            fieldOfficerName
              ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
              : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
          ),
          icon: <UserAddOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleGroupLoanActionButtons = (groupDetail) => {
  const { loanOfficerName } = groupDetail;
  const status = groupDetail?.status?.value;
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Approve Loan Account",
          key: "2",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("APPROVE_LOAN"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject Loan Account",
          key: "3",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("REJECT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "4",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Collateral",
          key: "5",
          route: "/group-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Modify Application",
          key: "6",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("UPDATE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Withdrawn By Client",
          key: "7",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("WITHDRAW_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "8",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "9",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "10",
          route: "/group-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Delete",
          key: "11",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("DELETE_LOAN"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "1",
          route: "/group-loan-action",
          disabled: loanOfficerName
            ? !BOM.HasPermission("REMOVELOANOFFICER_LOAN")
            : !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse",
          key: "7",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("DISBURSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse To Savings",
          key: "8",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("DISBURSETOSAVINGS_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Undo Approval",
          key: "2",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Loan Charge",
          key: "3",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "4",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "5",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "6",
          route: "/group-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Prepayment",
          key: "2",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: `${"Assign Loan Officer"}`,
          key: "3",
          route: "/group-loan-action",
          disabled:
            groupDetail.hasOwnProperty("loanOfficerId") &&
            BOM.HasPermission("UPDATELOANOFFICER_LOAN")
              ? true
              : false,
          icon: <SettingOutlined />,
        },
        {
          label: `${
            groupDetail.hasOwnProperty("loanOfficerId")
              ? "Unassign Loan Officer"
              : "Unassign Loan Officer"
          }`,
          key: "16",
          route: "/group-loan-action",
          disabled:
            groupDetail.hasOwnProperty("loanOfficerId") &&
            BOM.HasPermission("REMOVELOANOFFICER_LOAN")
              ? false
              : true,
          icon: <SettingOutlined />,
        },
        {
          label: "Foreclosure",
          key: "4",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("FORECLOSURE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Make Repayment",
          key: "5",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },

        {
          label: "Undo Disbursal",
          key: "6",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("DISBURSALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },

        {
          label: "Waive Interest",
          key: "7",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("WAIVEINTERESTPORTION_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Reschedule",
          key: "8",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_RESCHEDULELOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Write Off",
          key: "9",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("WRITEOFF_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close",
          key: "10",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CLOSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close As Rescheduled",
          key: "11",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CLOSEASRESCHEDULED_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "12",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "13",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Recover From Guarantor",
          key: "14",
          route: "/group-loan-action",
          disabled: !BOM.HasPermission("RECOVERGUARANTEES_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Report",
          key: "15",
          route: "/group-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.closed:
      return [{}];
    case accountStatus.rejected:
      return [{}];
    default:
      return [];
  }
};

export const handleGLIMLoanActionButtons = (groupDetail) => {
  const { loanOfficerName } = groupDetail;
  const status = groupDetail?.status?.value;
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Approve Loan Account",
          key: "2",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("APPROVE_LOAN"),
          icon: <SafetyOutlined />,
        },
        {
          label: "Reject Loan Account",
          key: "3",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("REJECT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "4",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Collateral",
          key: "5",
          route: "/glim-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Modify Application",
          key: "6",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("UPDATE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Withdrawn By Client",
          key: "7",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("WITHDRAW_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "8",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "9",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "10",
          route: "/glim-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: loanOfficerName
            ? "Change Loan Officer"
            : "Assign Loan Officer",
          key: "1",
          route: "/glim-loan-action",
          disabled: loanOfficerName
            ? !BOM.HasPermission("REMOVELOANOFFICER_LOAN")
            : !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse",
          key: "7",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("DISBURSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse To Savings",
          key: "8",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("DISBURSETOSAVINGS_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Undo Approval",
          key: "2",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Loan Charge",
          key: "3",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "4",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "5",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Reports",
          key: "6",
          route: "/glim-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Add Loan Charge",
          key: "1",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Prepayment",
          key: "2",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: loanOfficerName
            ? "Unassign Loan Officer"
            : "Assign Loan Officer",
          key: "3",
          route: "/glim-loan-action",
          disabled: loanOfficerName
            ? !BOM.HasPermission("REMOVELOANOFFICER_LOAN")
            : !BOM.HasPermission("UPDATELOANOFFICER_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Foreclosure",
          key: "4",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("FORECLOSURE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Make Repayment",
          key: "5",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("REPAYMENT_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Undo Disbursal",
          key: "6",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("DISBURSALUNDO_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Waive Interest",
          key: "7",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("WAIVEINTERESTPORTION_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Reschedule",
          key: "8",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_RESCHEDULELOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Write Off",
          key: "9",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("WRITEOFF_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close",
          key: "10",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CLOSE_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close As Rescheduled",
          key: "11",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CLOSEASRESCHEDULED_LOAN"),
          icon: <SettingOutlined />,
        },
        {
          label: "Create Guarantor",
          key: "12",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("CREATE_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "View Guarantors",
          key: "13",
          route: "/glim-loan-action",
          disabled: !BOM.HasPermission("READ_GUARANTOR"),
          icon: <SettingOutlined />,
        },
        {
          label: "Recover From Guarantor",
          key: "14",
          route: "/glim-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Loan Screen Report",
          key: "15",
          route: "/glim-loan-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.closed:
      return [{}];
    case accountStatus.rejected:
      return [{}];
    default:
      return [];
  }
};

export const handleGsimApplicationDetailActionButtons = (groupDetail) => {
  const { fieldOfficerName } = groupDetail;
  const status = groupDetail?.status?.value;
  const subStatusBlock = groupDetail?.subStatus?.block; //This needs to be checked later on for hold action implementation
  const subStatusNone = groupDetail?.subStatus?.none;

  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Modify Application",
          key: "1",
          route: "/group-gsim-action",
          disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
          icon: <EditOutlined />,
        },
        {
          label: "Approve",
          key: "2",
          route: "/group-gsim-action",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },

        {
          label: "Reject",
          key: "3",
          route: "/group-gsim-action",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];

    case accountStatus.active:
      return [
        {
          label: "Deposit",
          key: "1",
          route: "/group-gsim-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("DEPOSIT_SAVINGSACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Close",
          key: "2",
          route: "/group-gsim-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CLOSE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];

    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/group-gsim-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_SAVINGSACCOUNT"),
          icon: <VerticalAlignMiddleOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/group-gsim-action",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
      ];

    default:
      return [];
  }
};

export const handleChildGsimAccountDetailActionButtons = (groupDetail) => {
  const { fieldOfficerName } = groupDetail;
  const status = groupDetail?.status?.value;

  const subStatusBlock = groupDetail?.subStatus?.block;
  const subStatusNone = groupDetail?.subStatus?.none;
  switch (status.toLowerCase()) {
    case accountStatus.submittedAndPending:
      return [
        {
          label: "Approve",
          key: "1",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "2",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission(
            fieldOfficerName
              ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
              : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
          ),
          icon: <UserAddOutlined />,
        },
        {
          label: "Add Charge",
          key: "4",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: "Reject",
          key: "5",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
        {
          label: "Withdrawn by Client",
          key: "6",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("WITHDRAW_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Modify Application",
          key: "7",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
          icon: <EditOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Undo Approval",
          key: "1",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("APPROVALUNDO_SAVINGSACCOUNT"),
          icon: <VerticalAlignMiddleOutlined />,
        },
        {
          label: "Activate",
          key: "2",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <UserAddOutlined />,
        },
        {
          label: "Add Charge",
          key: "3",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/group-gsim-account-action",
          disabled: !BOM.HasPermission(
            fieldOfficerName
              ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
              : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
          ),
          icon: <UserAddOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Post Interest As On",
          key: "1",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
          icon: <DoubleRightOutlined />,
        },
        {
          label: "Deposit",
          key: "2",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("DEPOSIT_SAVINGSACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Withdraw",
          key: "3",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("WITHDRAWAL_SAVINGSACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Calculate Interest",
          key: "4",
          disabled:
            subStatusBlock ||
            !BOM.HasPermission("CALCULATEINTEREST_SAVINGSACCOUNT"),
          icon: <CalculatorOutlined />,
        },
        {
          label: subStatusBlock ? "Unhold" : "Hold",
          key: "5",
          route: "/group-gsim-account-action",
          disabled: subStatusBlock
            ? subStatusNone
            : subStatusBlock || !BOM.HasPermission("HOLD_SAVINGSACCOUNT"),
          icon: <HolderOutlined />,
        },
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "6",
          route: "/group-gsim-account-action",
          disabled: subStatusBlock
            ? subStatusNone
            : subStatusBlock ||
              !BOM.HasPermission(
                fieldOfficerName
                  ? "REMOVESAVINGSOFFICER_SAVINGSACCOUNT"
                  : "UPDATESAVINGSOFFICER_SAVINGSACCOUNT"
              ),
          icon: <UserAddOutlined />,
        },
        {
          label: "Post Interest",
          key: "7",
          disabled:
            subStatusBlock || !BOM.HasPermission("POSTINTEREST_SAVINGSACCOUNT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Add Charge",
          key: "8",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CREATE_SAVINGSACCOUNTCHARGE"),
          icon: <UploadOutlined />,
        },
        {
          label: "Close",
          key: "9",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CLOSE_SAVINGSACCOUNT"),
          icon: <CloseOutlined />,
        },

        {
          label: "Transfer Funds",
          key: "10",
          route: "/group-gsim-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CREATE_ACCOUNTTRANSFER"),
          icon: <DoubleRightOutlined />,
        },
        {
          label: "Manage Account",
          key: "11",
          route: "/group-gsim-account-action",
          disabled: true,
          icon: <EditOutlined />,
        },
        {
          label: "KYC",
          key: "12",
          route: "/group-gsim-account-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.block:
      return [
        {
          label: "Unhold Account",
          key: "1",
          route: "/unhold-account",
          disabled: true,
          icon: <HolderOutlined />,
        },
      ];
    case accountStatus.withdrawnByApplicant:
      return [
        {
          label: fieldOfficerName ? "Unassign Officer" : "Assign Officer",
          key: "4",
          route: "/group-gsim-account-action",
          disabled: true,
          icon: <UserAddOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const accountStatus = {
  submittedAndPending: "submitted and pending approval",
  approved: "approved",
  active: "active",
  block: "block",
  withdrawnByApplicant: "withdrawn by applicant",
  rejected: "rejected",
  closed: "closed",
  prematureClosed: "Premature Closed",
  matured: "matured",
};
